import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface BackButtonProps {
  to?: string; 
}

const BackButton: React.FC<BackButtonProps> = ({ to }) => {
  const navigate = useNavigate();
  
  const goBack = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1); 
    }
  };

  return (
    <Button onClick={goBack}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 12H5" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 19L5 12L12 5" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </Button>
  );
};

export default BackButton;

const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius:50%;
  transition: transform 0.3s ease-in-out, background-color 0.2s ease;

  &:hover {
    background-color: #f0f0f0; 
    transform: scale(1.05);
    border-radius: 50%; 
  }
`;